export default __webpack_public_path__ + "static/media/master_b5epb.247eff53.jpg";